import React from 'react';
import NavBar from '../../components/navbar';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import MenuItem from '../../components/menu/menuItem';

const PaintCapacityPage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Capacidad Taller', link: '/account' },
  ];

  const isReadOnly = props.user.tags.includes('read-only');

  return (
    <div id="main-account" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="account" items={breadcrumbItems} />
      <div className="menu-container">
        <MenuItem
          key="feed_admin"
          title="Dashboard Capacidad Taller"
          text="Dashboard"
          icon="dashboard"
          link="/paint-capacity-dashboard"
        />
        { !isReadOnly &&
          <MenuItem
            title="Crear Pedido a taller"
            text="Crear nuevo pedido"
            icon="colorize"
            link="/paint-capacity-create"
          />
        }
      </div>
    </div>
  );
};

export default PaintCapacityPage;
